import React, { useMemo } from "react";

function OutputArray({ field, object, collection, selectedItem }) {
  const value = object[field];
  const collectionType = collection.collection;

  const filteredItems = useMemo(() => {
    if (!Array.isArray(value) || value.length === 0) return [];

    // if it's an array of strings
    const isStringArray = typeof value[0] === "string";

    if (isStringArray) {
      if (Array.isArray(selectedItem) && selectedItem.length > 0) {
        return value.filter((item) =>
          selectedItem.every((keyword) => item.includes(keyword))
        );
      } else if (selectedItem && selectedItem !== "") {
        return value.filter((item) => item.includes(selectedItem));
      }
      return value;
    } else {
      // assume array of objects with a "name" property
      if (Array.isArray(selectedItem) && selectedItem.length > 0) {
        return value.filter((item) =>
          selectedItem.every((keyword) =>
            item.name?.toLowerCase().includes(keyword.toLowerCase())
          )
        );
      } else if (selectedItem && selectedItem !== "") {
        return value.filter((item) =>
          item.name?.toLowerCase().includes(selectedItem.toLowerCase())
        );
      }
      return value;
    }
  }, [value, selectedItem]);

  if (filteredItems.length === 0) return null;

  return (
    <>
      {collectionType === "daily_time_record" ? (
        <div className="d-flex gap-2 p-0">
          {value.map((item, index) => (
            <span
              key={index}
              style={{
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid orange",
                backgroundColor: "#fef4e8",
                color: "orange",
              }}
            >
              {typeof item === "string" ? item : item.name}
            </span>
          ))}
        </div>
      ) : (
        <div className="d-grid p-0">
          {filteredItems.map((item, index) => (
            <span key={index} style={{ padding: "5px" }}>
              {typeof item === "string" || typeof item === "number"
                ? item
                : item?.name}
            </span>
          ))}
        </div>
      )}
    </>
  );
}

export default OutputArray;
